'use strict';
import {addCustomEventListener, addClass, removeClass, hasClass} from '../helpers';

export const homeVideo = (() => {
  const _curSor = document.getElementById('curSor');
  let _video;
  let _mp4;
  let isPlaying = false;
  let isEnded = false;

  const eventListeners = () => {
    addCustomEventListener('[data-btn="toggle-play"]','click', function () {
      isPlaying = !isPlaying;
      if (isPlaying) {
        const src = _video.getAttribute('data-video');
        if (!_mp4.getAttribute('src')) {
          _mp4.setAttribute('src', src);
        }
        _mp4.play();
      } else {
        _mp4.pause();
      }
    });
    _mp4.onended = () => {
      isPlaying = false;
      // console.log('video ended');
      removeClass(_video, 'playing');
      window.shApp.cursor.togglePlayerCur('show');
    };
    _mp4.onpause = () => {
      isPlaying = false;
      // console.log('video paused');
      removeClass(_video, 'playing');
      window.shApp.cursor.togglePlayerCur('show');
    };
    _mp4.onplay = () => {
      // console.log('video played');
      addClass(_video, 'playing');

      window.shApp.cursor.togglePlayerCur('hide');
    };
    _mp4.onwaiting = () => {
      console.log('video is waiting');
    };
  };

  const init = () => {
    _video = document.querySelector('.home_video');
    _mp4 = document.querySelector('.home_video__mp4');
    if (!_video) return false;
    eventListeners();
  };

  return {
    init
  }
})();
